import {
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useEffect} from 'react';

import api from 'services/api/api';
import {tdsUrlPath} from 'utils/string';

export const useReadOcrm = (url: string | undefined) => {
  const token = useWidgetState(Selectors.sectokenSelector);
  useEffect(() => {
    const apiAsync = async () => {
      try {
        if (!url) {
          return;
        }

        await api.request({
          method: 'POST',
          url: tdsUrlPath(url),

          headers: {
            Authorization: token,
            'Content-Type': 'text/plain',
            accept: 'application/json',
          },
        });
      } catch (e) {}
    };
    apiAsync();
  }, [token, url]);
};
